import { createAsyncThunk } from '@reduxjs/toolkit'
import doAsync from '../../infrastructure/doAsync'
import { REGIONS } from '../../widgets/busyIndicator'

export const deleteDocument = createAsyncThunk(
	'documents/Delete',
	async (documentId, thunkArgs, { useCaching = true, noBusySpinner } = {}) =>
		await doAsync({
			url: `api/documents/${documentId}`,
			httpMethod: 'delete',
			useCaching,
			noBusySpinner,
			busyIndicatorName: REGIONS.DELETE_DOCUMENT,
			successMessage: 'Document Deleted',
			errorMessage: 'Unable to delete document. Please try again later.',
			...thunkArgs,
		})
)
